import { HttpClient } from '@angular/common/http';
import {Injectable} from '@angular/core';
import {Observable} from 'rxjs';
import {environment} from '../../../../environments/environment';
import {PagedRequestDTO} from '../../common/models/PagedRequestDTO';
import {PagedResponseDTO} from '../../common/models/PagedResponseDTO';
import {ApplicationDTO} from '../models/application/ApplicationDTO';
import {ApplicationStatusLookupDTO} from '../models/application/ApplicationStatusLookupDTO';
import {BulkApplicationDTO} from '../models/application/BulkApplicationDTO';

@Injectable({
  providedIn: 'root'
})
export class OnboardingAdminPortalService {
  private url = environment.baseUrl + '/application-onboard';
  private integrationUrlBase = environment.baseIgnUrl + '/application-onboard';
  private workflowUrl = environment.baseWeUrl + '/application-onboard';

  constructor(private httpClient: HttpClient) {
  }

  getListOfApplications(pagedRequestDTO: PagedRequestDTO): Observable<PagedResponseDTO<ApplicationDTO>> {
    return this.httpClient.post<PagedResponseDTO<ApplicationDTO>>(this.url + '/filter', pagedRequestDTO);
  }

  getApplicationById(applicationId: number): Observable<ApplicationDTO> {
    return this.httpClient.get<ApplicationDTO>(`${this.url}/${applicationId}`);
  }

  updateApplication(application: ApplicationDTO): Observable<ApplicationDTO> {
    return this.httpClient.post<ApplicationDTO>(this.url, application);
  }

  processApplication(application: ApplicationDTO): Observable<ApplicationDTO> {
    return this.httpClient.post<ApplicationDTO>(this.integrationUrlBase + '/internal', application);
  }

  sendWelcomePack(application: ApplicationDTO): Observable<void> {
    return this.httpClient.post<void>(this.workflowUrl + '/send-welcome-pack/test', application);
  }

  getApplicationByIdNumberAndStatus(idNumber: any, statusId: number): Observable<ApplicationDTO> {
    return this.httpClient.get<ApplicationDTO>(`${this.url}/id-number`, {params: {idNumber, statusId}});
  }

  bulkImportApplications(bulkApplication: BulkApplicationDTO): Observable<void> {
    return this.httpClient.post<void>(this.integrationUrlBase + '/bulk-import', bulkApplication);
  }

  getApplicationStatusV2(membershipNumber: string, brokerCode: string): Observable<ApplicationStatusLookupDTO> {
    return this.httpClient.get<ApplicationStatusLookupDTO>(`${environment.baseIgnUrl}/application-onboard/status/v2`, {
      params: {
        membershipNumber,
        brokerCode
      }
    });
  }
}
